export default __webpack_public_path__ + "static/media/contacto.d9304618.png";